import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        'birthCountrySelect',
        'fieldset'
    ]

    static values = {
        country: String,
        optionnalInputs: Array, // affichés uniquement si naissance à l'étranger
        franceInputs: Array     // affichés uniquement si naissance en France
    }

    connect() {
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let Select2 instances to correctly initialize
        setTimeout(() => {
          this.setTextInputs();
        }, 10)
    }

    setTextInputs() {
        const bornInFrance = this.birthCountrySelectTarget.value === this.countryValue;
        this.fieldsetTargets.forEach(fieldset => {
            const name = fieldset.dataset.fieldsetName;
            if (this.optionnalInputsValue.includes(name)) {
                this.toggle(fieldset, !bornInFrance);
            } else if (this.hasFranceInputsValue && this.franceInputsValue.includes(name)) {
                this.toggle(fieldset, bornInFrance);
            }
        })
    }

    toggle(fieldset, show) {
        fieldset.disabled = !show;
        fieldset.style.display = show ? 'block' : 'none';
    }
}
